import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import CuratedMediaList from './curated-media-list-model'
import {
  CreateCuratedMediaListAsync,
  DeleteCuratedMediaListAsync,
  LoadCuratedMediaListsAsync,
} from './curatedMediaList-thunk'
const initialState: curatedMediaListSliceState = {
  curatedMediaList: [],
  selected_curatedMediaList: '',
  is_loading_curatedMediaList: false,
  is_creating_curatedMediaList: false,
  is_deleting_curatedMediaList: false,
}
export interface curatedMediaListSliceState {
  curatedMediaList: CuratedMediaList[]
  selected_curatedMediaList?: string
  is_loading_curatedMediaList: boolean
  is_creating_curatedMediaList: boolean
  is_deleting_curatedMediaList: boolean
}
export const curatedMediaListSlice = createSlice({
  name: 'curatedMediaList',
  initialState,
  reducers: {
    setSelectedcuratedMediaList: (state, action) => {
      state.selected_curatedMediaList = action.payload
    },
    clearStatecuratedMediaList: (state) => {
      state.curatedMediaList = []
      state.is_loading_curatedMediaList = false
      state.is_creating_curatedMediaList = false
      state.is_deleting_curatedMediaList = false
    },
    mergecuratedMediaList: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_curatedMediaList = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.curatedMediaList = merge(state.curatedMediaList, payload) as any
        }
      }
    },

    add_curatedMediaList: (state, action) => {
      if (action.payload) {
        state.curatedMediaList = [...state.curatedMediaList, action.payload]
      }
    },
    set_curatedMediaList: (state, action) => {
      let { key, value, id } = action.payload
      state.curatedMediaList = state.curatedMediaList.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCuratedMediaListsAsync.pending, (state) => {
      state.is_loading_curatedMediaList = true
    })
    builder.addCase(LoadCuratedMediaListsAsync.fulfilled, (state, action) => {
      state.is_loading_curatedMediaList = false
      if (action.payload) {
        state.curatedMediaList = action.payload
      }
    })
    builder.addCase(LoadCuratedMediaListsAsync.rejected, (state) => {
      state.is_loading_curatedMediaList = false
    })
    builder.addCase(CreateCuratedMediaListAsync.pending, (state) => {
      state.is_creating_curatedMediaList = true
    })
    builder.addCase(CreateCuratedMediaListAsync.fulfilled, (state) => {
      state.is_creating_curatedMediaList = false
    })
    builder.addCase(CreateCuratedMediaListAsync.rejected, (state) => {
      state.is_creating_curatedMediaList = false
    })
    builder.addCase(DeleteCuratedMediaListAsync.pending, (state) => {
      state.is_deleting_curatedMediaList = true
    })
    builder.addCase(DeleteCuratedMediaListAsync.fulfilled, (state, action) => {
      state.is_deleting_curatedMediaList = false
      if (state.curatedMediaList) {
        state.curatedMediaList = state.curatedMediaList.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteCuratedMediaListAsync.rejected, (state) => {
      state.is_deleting_curatedMediaList = false
    })

    builder.addCase(autoThunks.update_curated_media_list.pending, (state) => {
      state.is_loading_curatedMediaList = true
    })
    builder.addCase(
      autoThunks.update_curated_media_list.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.update_curated_media_list.rejected, (state) => {
      state.is_loading_curatedMediaList = false
    })

    builder.addCase(
      autoThunks.get_customer_curated_media_lists.pending,
      (state) => {
        state.is_loading_curatedMediaList = true
      },
    )
    builder.addCase(
      autoThunks.get_customer_curated_media_lists.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_customer_curated_media_lists.rejected,
      (state) => {
        state.is_loading_curatedMediaList = false
      },
    )

    builder.addCase(
      autoThunks.get_curated_media_list_for_user.pending,
      (state) => {
        state.is_loading_curatedMediaList = true
      },
    )
    builder.addCase(
      autoThunks.get_curated_media_list_for_user.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_curated_media_list_for_user.rejected,
      (state) => {
        state.is_loading_curatedMediaList = false
      },
    )

    builder.addCase(autoThunks.load_curated_media_list.pending, (state) => {
      state.is_loading_curatedMediaList = true
    })
    builder.addCase(
      autoThunks.load_curated_media_list.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_curated_media_list.rejected, (state) => {
      state.is_loading_curatedMediaList = false
    })

    builder.addCase(autoThunks.get_curated_media_list.pending, (state) => {
      state.is_loading_curatedMediaList = true
    })
    builder.addCase(
      autoThunks.get_curated_media_list.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_curated_media_list.rejected, (state) => {
      state.is_loading_curatedMediaList = false
    })

    builder.addCase(autoThunks.storeCuratedMediaListAsync.pending, (state) => {
      state.is_loading_curatedMediaList = true
    })
    builder.addCase(
      autoThunks.storeCuratedMediaListAsync.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.storeCuratedMediaListAsync.rejected, (state) => {
      state.is_loading_curatedMediaList = false
    })

    builder.addCase(autoThunks.deleteCuratedMediaListAsync.pending, (state) => {
      state.is_loading_curatedMediaList = true
    })
    builder.addCase(
      autoThunks.deleteCuratedMediaListAsync.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.deleteCuratedMediaListAsync.rejected,
      (state) => {
        state.is_loading_curatedMediaList = false
      },
    )

    builder.addCase(autoThunks.get_all_curated_media.pending, (state) => {
      state.is_loading_curatedMediaList = true
    })
    builder.addCase(
      autoThunks.get_all_curated_media.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_all_curated_media.rejected, (state) => {
      state.is_loading_curatedMediaList = false
    })

    builder.addCase(
      autoThunks.load_curated_media_list_for_system_schedules.pending,
      (state) => {
        state.is_loading_curatedMediaList = true
      },
    )
    builder.addCase(
      autoThunks.load_curated_media_list_for_system_schedules.fulfilled,
      (state, action) => {
        state.is_loading_curatedMediaList = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_curated_media_list_for_system_schedules.rejected,
      (state) => {
        state.is_loading_curatedMediaList = false
      },
    )
  },
})

function handleResult(action: any, state: curatedMediaListSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_curatedMediaList = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.curatedMediaList = merge(state.curatedMediaList, payload) as any
    }
  }
}

export const {
  clearStatecuratedMediaList,
  setSelectedcuratedMediaList,
  set_curatedMediaList,
  mergecuratedMediaList,
  add_curatedMediaList,
} = curatedMediaListSlice.actions

export const get_curatedMediaList =
  (id?: string) =>
  (state: {
    curatedMediaList: {
      curatedMediaList: CuratedMediaList[]
    }
  }): CuratedMediaList | null => {
    let temp = state?.curatedMediaList?.curatedMediaList?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.curatedMediaList?.curatedMediaList[0] || null
  }
export const get_selected_curatedMediaList = (state: {
  curatedMediaList: curatedMediaListSliceState
}): CuratedMediaList | null => {
  let id = state?.curatedMediaList?.selected_curatedMediaList
  let temp = state?.curatedMediaList?.curatedMediaList?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_curatedMediaList = (state: {
  curatedMediaList: {
    curatedMediaList: CuratedMediaList[]
  }
}): CuratedMediaList[] => {
  let temp = state?.curatedMediaList?.curatedMediaList
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_curatedMediaList_busy = (state: {
  curatedMediaList: curatedMediaListSliceState
}) => {
  return (
    state?.curatedMediaList.is_deleting_curatedMediaList ||
    state?.curatedMediaList.is_loading_curatedMediaList ||
    state?.curatedMediaList.is_creating_curatedMediaList
  )
}
export const is_deleting_curatedMediaList_busy = (state: {
  curatedMediaList: curatedMediaListSliceState
}) => {
  return state?.curatedMediaList.is_deleting_curatedMediaList
}
export const is_loading_curatedMediaList_busy = (state: {
  curatedMediaList: curatedMediaListSliceState
}) => {
  return state?.curatedMediaList.is_loading_curatedMediaList
}
export const is_creating_curatedMediaList_busy = (state: {
  curatedMediaList: curatedMediaListSliceState
}) => {
  return state?.curatedMediaList.is_creating_curatedMediaList
}

export default curatedMediaListSlice.reducer
